export default {
    titulo: "Reports",
    reparaciones: "Workshop Repairs",
    detalle: "Detailed Information",
    tipoMarcaModelo: "By Type, Brand, and Model",
    servicios: "Field Services",
    tipoArea: "By Type and Area",
    gestion: "Management Indicators",
    fallas: "Services by Issues",
    stock: "Stock",
    compras: "Purchases",
    costos: "Material Costs by Family",
    consumo: "Material Consumption in Maintenance",
    repuestos: "Spare Parts Used in Orders",
    satisfaccion: "Customer Satisfaction",
    encuesta: "Satisfaction Surveys",
    productividad: "Productivity",
    comisiones: "Commissions per Technician",
    estadisticasServ: "Service Statistics",
    estadisticasRep: "Repair Statistics",
    ordenarPor: "Sort by",
    nroOrden: "Order Number",
    ingreso: "Entry Date",
    fin: "Completion Date",
    entrega: "Delivery Date",
    tituloCompras: "Purchases Report",
    tituloComisiones: "Commissions per Technician Report",
    tituloCostos: "Material Costs by Family Report",
    tituloEncuestas: "Satisfaction Survey Report",
    aplicada: "Applied to",
    opcionRep: "Repair Orders",
    opcionServ: "Service Orders",
    repYserv: "Repair and Service Orders",
    seleccionarCliente: "Select a Client",
    clienteSeleccionado: "Selected Client",
    tituloServ: "Service Report",
    tituloRep: "Repair Report",
    estados: "Statuses",
    notificado: "Notified",
    noNotificado: "Not Notified",
    entregado: "Delivered",
    finalizado: "Completed",
    tituloRepuestos: "Report of Spare Parts Used in Orders",
    tituloTipoArea: "Report of Services by Type and Area",
    eficacia: "Effectiveness",
    aTiempo: "On Time",
    tarde: "Late"
}
